import { render, staticRenderFns } from "./StrataProjects.vue?vue&type=template&id=248a4d04&scoped=true&"
import script from "./StrataProjects.vue?vue&type=script&lang=js&"
export * from "./StrataProjects.vue?vue&type=script&lang=js&"
import style0 from "./StrataProjects.vue?vue&type=style&index=0&id=248a4d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a4d04",
  null
  
)

export default component.exports